import { useRouter } from 'next/router';
import Text from '@components/common/text';
import Icon from '@components/common/assets';
import SnsShare from '@components/common/snsShare';
import Notice from './notice';
import Review from './review';
import CommentList from './commentList';
import PassReviewPostGetRs from '@domain/rs/passReview/PassReviewPostGetRs';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface Props {
  reviewData: PassReviewPostGetRs;
}

const Contents = ({ reviewData }: Props) => {
  const router = useRouter();
  const { query } = router;

  if (!reviewData) return null;

  return (
    <div className={cx('wrapper')}>
      <Text className={cx('title')} fontStyle={FontStyle.H3_B} color={Colors.C_COOL_GRAY_90}>
        {reviewData.title}
      </Text>

      <div className={cx('infoArea')}>
        <div className={cx('infoText')}>
          <Text
            fontStyle={FontStyle.B3P_M}
            color={Colors.C_COOL_GRAY_60}
            styles={{ display: 'flex', alignItems: 'center', gap: '4px' }}
          >
            <Icon name="calenderLight" width={24} height={24} fill={Colors.C_COOL_GRAY_60} />
            {DateFormat.format(new Date(reviewData.createdDateTime), 'yyyy.MM.dd')}
          </Text>
          <div className={cx('divider')} />
          <Text
            fontStyle={FontStyle.B3P_M}
            color={Colors.C_COOL_GRAY_60}
            styles={{ display: 'flex', alignItems: 'center', gap: '4px' }}
          >
            <Icon name="visibilityLight" width={24} height={24} fill={Colors.C_COOL_GRAY_60} />
            {reviewData.views}
          </Text>
        </div>

        <SnsShare
          title={reviewData.title}
          description="지원부터 합격까지 필요한 모든 꿀팁이 한 곳에 모였다."
          btnText="자세히 보기"
          webUrl={`https://www.jobda.im/passboard/${query.sn}`}
          mobileWebUrl={`https://m.jobda.im/passboard/${query.sn}`}
          imageUrl={'https://www.jobda.im/img/v2/components/share/imgSharePassboard.png'}
        />
      </div>

      <div className={cx('divider')} />

      {reviewData.type === 'NOTICE' ? <Notice reviewData={reviewData} /> : <Review reviewData={reviewData} />}

      <CommentList reviewData={reviewData} />
    </div>
  );
};

export default Contents;
